import React from 'react';
import { Card } from '@monorepo/base/src/components/card/card';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore } from '../../../../stores';
import styles from './bidder-initial-bids.module.scss';
import { Input } from '@monorepo/base/src/components/form/input/input';
import { observer } from 'mobx-react';

export const BidderInitialBids = observer(() => {
	const { bidderStore } = useStores<IAdminxStore>();

	const campaignCrudStore = bidderStore.getCrud();
	const formStore = campaignCrudStore.getFormStore();
	const campaign = campaignCrudStore.getData().campaign;

	if (campaign === undefined) {
		return null;
	}

	const setValue = (field: string, value: number | string) => {
		campaign.campaign_initial_bids = {
			...campaign.campaign_initial_bids,
			[field]: value,
		};
	};

	const setWithSaleValue = (field: string, value: number | string) => {
		campaign.campaign_bids_new_with_sale = {
			...campaign.campaign_bids_new_with_sale,
			[field]: value,
		};
	};

	return (
		<React.Fragment>
			<Card icon={'settings-01'} title={'New Domains'} id={'initialBids'} className={styles.wrapper}>
				<div className={styles.bidRangeRow}>
					<div className={styles.bidColumn}>
						<div className={styles.bidRange}>
							<Input
								value={campaign.campaign_initial_bids?.minimal_bid?.toString()}
								placeholder={'Minimal Bid'}
								type={'number'}
								onValue={value => {
									setValue('minimal_bid', value);
									formStore.clearError('campaign_initial_bids.minimal_bid');
								}}
								error={formStore.getErrors().get('campaign_initial_bids.minimal_bid')?.getMsg()}
							/>
							<span>-</span>
							<Input
								value={campaign.campaign_initial_bids?.maximum_bid?.toString()}
								placeholder={'Maximum Bid'}
								type={'number'}
								onValue={value => {
									setValue('maximum_bid', value);
									formStore.clearError('campaign_initial_bids.maximum_bid');
								}}
								error={formStore.getErrors().get('campaign_initial_bids.maximum_bid')?.getMsg()}
							/>
						</div>
						<Input
							value={campaign.campaign_initial_bids?.random_bid_step?.toString()}
							placeholder={'Step'}
							type={'number'}
							onValue={value => {
								setValue('random_bid_step', value);
								formStore.clearError('campaign_initial_bids.random_bid_step');
							}}
							error={formStore.getErrors().get('campaign_initial_bids.random_bid_step')?.getMsg()}
						/>
					</div>
					<div className={styles.bidColumn}>
						<div className={styles.bidRange}>
							<Input
								value={campaign.campaign_initial_bids?.high_minimal_bid?.toString()}
								placeholder={'High Minimal Bid'}
								type={'number'}
								onValue={value => {
									setValue('high_minimal_bid', value);
									formStore.clearError('campaign_initial_bids.high_minimal_bid');
								}}
								error={formStore.getErrors().get('campaign_initial_bids.high_minimal_bid')?.getMsg()}
							/>
							<span>-</span>
							<Input
								value={campaign.campaign_initial_bids?.high_maximum_bid?.toString()}
								placeholder={'High Maximum Bid'}
								type={'number'}
								onValue={value => {
									setValue('high_maximum_bid', value);
									formStore.clearError('campaign_initial_bids.high_maximum_bid');
								}}
								error={formStore.getErrors().get('campaign_initial_bids.high_maximum_bid')?.getMsg()}
							/>
						</div>
						<Input
							value={campaign.campaign_initial_bids?.high_random_bid_step?.toString()}
							placeholder={'High Step'}
							type={'number'}
							onValue={value => {
								setValue('high_random_bid_step', value);
								formStore.clearError('campaign_initial_bids.high_random_bid_step');
							}}
							error={formStore.getErrors().get('campaign_initial_bids.high_random_bid_step')?.getMsg()}
						/>
					</div>
				</div>
				<Input
					value={campaign.campaign_initial_bids?.max_loss_per_key?.toString()}
					placeholder={'Max Loss per Domain'}
					type={'number'}
					onValue={value => {
						setValue('max_loss_per_key', parseInt(value ?? 0));
						formStore.clearError('campaign_initial_bids.max_loss_per_key');
					}}
					error={formStore.getErrors().get('campaign_initial_bids.max_loss_per_key')?.getMsg()}
				/>
				<Input
					value={campaign.campaign_initial_bids?.max_num_Of_clicks_to_first_conv?.toString()}
					placeholder={'Max Clicks to First Conversion'}
					type={'number'}
					onValue={value => {
						setValue('max_num_Of_clicks_to_first_conv', parseInt(value ?? 0));
						formStore.clearError('campaign_initial_bids.max_num_Of_clicks_to_first_conv');
					}}
					error={formStore.getErrors().get('campaign_initial_bids.max_num_Of_clicks_to_first_conv')?.getMsg()}
				/>
			</Card>
			<Card icon={'settings-01'} title={'New Domains With Sale'} id={'newDomainsWithSale'} className={styles.wrapper}>
				<div className={styles.bidRangeRow}>
					<div className={styles.bidColumn}>
						<div className={styles.bidRange}>
							<Input
								value={campaign.campaign_bids_new_with_sale?.minimal_bid?.toString()}
								placeholder={'Minimal Bid'}
								type={'number'}
								onValue={value => {
									setWithSaleValue('minimal_bid', value);
									formStore.clearError('campaign_bids_new_with_sale.minimal_bid');
								}}
								error={formStore.getErrors().get('campaign_bids_new_with_sale.minimal_bid')?.getMsg()}
							/>
							<span>-</span>
							<Input
								value={campaign.campaign_bids_new_with_sale?.maximum_bid?.toString()}
								placeholder={'Maximum Bid'}
								type={'number'}
								onValue={value => {
									setWithSaleValue('maximum_bid', value);
									formStore.clearError('campaign_bids_new_with_sale.maximum_bid');
								}}
								error={formStore.getErrors().get('campaign_bids_new_with_sale.maximum_bid')?.getMsg()}
							/>
						</div>
						<Input
							value={campaign.campaign_bids_new_with_sale?.random_bid_step?.toString()}
							placeholder={'Step'}
							type={'number'}
							onValue={value => {
								setWithSaleValue('random_bid_step', value);
								formStore.clearError('campaign_bids_new_with_sale.random_bid_step');
							}}
							error={formStore.getErrors().get('campaign_bids_new_with_sale.random_bid_step')?.getMsg()}
						/>
					</div>
					<div className={styles.bidColumn}>
						<div className={styles.bidRange}>
							<Input
								value={campaign.campaign_bids_new_with_sale?.high_minimal_bid?.toString()}
								placeholder={'High Minimal Bid'}
								type={'number'}
								onValue={value => {
									setWithSaleValue('high_minimal_bid', value);
									formStore.clearError('campaign_bids_new_with_sale.high_minimal_bid');
								}}
								error={formStore.getErrors().get('campaign_bids_new_with_sale.high_minimal_bid')?.getMsg()}
							/>
							<span>-</span>
							<Input
								value={campaign.campaign_bids_new_with_sale?.high_maximum_bid?.toString()}
								placeholder={'High Maximum Bid'}
								type={'number'}
								onValue={value => {
									setWithSaleValue('high_maximum_bid', value);
									formStore.clearError('campaign_bids_new_with_sale.high_maximum_bid');
								}}
								error={formStore.getErrors().get('campaign_bids_new_with_sale.high_maximum_bid')?.getMsg()}
							/>
						</div>
						<Input
							value={campaign.campaign_bids_new_with_sale?.high_random_bid_step?.toString()}
							placeholder={'High Step'}
							type={'number'}
							onValue={value => {
								setWithSaleValue('high_random_bid_step', value);
								formStore.clearError('campaign_bids_new_with_sale.high_random_bid_step');
							}}
							error={formStore.getErrors().get('campaign_bids_new_with_sale.high_random_bid_step')?.getMsg()}
						/>
					</div>
				</div>
			</Card>
		</React.Fragment>
	);
});
